<template>
  <div>
    <div class="relative">
      <input
        class="m0 no-outline"
        type="checkbox"
        :id="id"
        :checked="value"
        @keyup.enter="$emit('click')"
        @click="$emit('click')"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.checked)"
        :disabled="disabled"
      >
      <label
        class="lh20 pointer"
        :class="isNewsletter ? 'second-label h6' : 'main-label pl35'"
        :for="id"
      >
        <slot />
      </label>
    </div>
    <ValidationMessages :class="{'newsletter-error': isNewsletter}" v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BaseCheckbox',
  components: {
    ValidationMessages
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    validations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isNewsletter: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-silver: color(silver);
  $color-main: color(main);
  $color-active: color(gray);
  $color-white: color(white);

  .newsletter-error {
    position: absolute;
    bottom: -10px;
    left: 50px;
  }
  .main-label {
    font-size: 0.8em;
    user-select: none;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      width: 16px;
      height: 16px;
      border-radius: 50px;
      background-color: $color-white;
      border: 1px solid $color-silver;
      cursor: pointer;
    }
  }

  .second-label {
    user-select: none;
    padding-left: 35px;
    @media (max-width: 767px) {
      padding-left: 25px;
    }
    &:before {
      content: '';
      position: absolute;
      top: 6px;
      left: 0;
      width: 14px;
      height: 14px;
      background-color: $color-white;
      border: 1px solid $color-silver;
      cursor: pointer;
    }
  }

  input {
    position: absolute;
    top: 3px;
    left: 0;
    opacity: 0;
    &:checked + label {
      &:before {
        border-radius: 50px;
        background-color: $color-main;
        border-color: $color-main;
        cursor: pointer;
      }
      &:after {
        content: '';
        position: absolute;
        top: 9px;
        left: 5px;
        width: 6px;
        height: 3px;
        border: 2px solid $color-white;
        border-top: none;
        border-right: none;
        background-color: $color-main;
        transform: rotate(-45deg);
      }
    }
    &:hover,
    &:focus {
      + label {
        &:before {
          border-color: $color-main;
        }
      }
    }
    &:disabled + label {
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
      &:hover,
      &:focus {
        &:before {
          border-color: $color-silver;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
